<template>
  <div class="w-100">
    <file-list></file-list>
  </div>
</template>

<script>
import FileList from './file/fileList.vue'
export default {
  components: {
    FileList
  }
}
</script>

<style>
</style>